function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.125 11C7.84833 11 9.25 9.59833 9.25 7.875V3.5C9.25 3.26959 9.06331 3.08336 8.83336 3.08336C8.60333 3.08336 8.41664 3.26959 8.41664 3.5V7.875C8.41664 9.13835 7.38873 10.1666 6.125 10.1666C4.86127 10.1666 3.83336 9.13835 3.83336 7.875V3.29164C3.83336 2.4875 4.4875 1.83336 5.29164 1.83336C6.09586 1.83336 6.75 2.4875 6.75 3.29164V7.45836C6.75 7.8029 6.46962 8.08336 6.125 8.08336C5.78038 8.08336 5.5 7.8029 5.5 7.45836V3.5C5.5 3.26959 5.31331 3.08336 5.08336 3.08336C4.85333 3.08336 4.66664 3.26959 4.66664 3.5V7.45836C4.66664 8.2625 5.32086 8.91664 6.125 8.91664C6.92914 8.91664 7.58336 8.2625 7.58336 7.45836V3.29164C7.58336 2.02837 6.55545 1 5.29164 1C4.02791 1 3 2.02837 3 3.29164V7.875C3 9.59833 4.40167 11 6.125 11Z",
  fill: "#09090A"
});

function SvgIconPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.cd5b2f39.svg";
export { ForwardRef as ReactComponent };